import axios, { AxiosResponse } from 'axios';
import { createRequestConfig } from './utils';
import EqHis from '../models/data/EqHis';
import EqHisRequest, { EqHisDetailRequest } from '../models/requests/GetEqHis';

// 設備点検情報の取得関数
export default function requestEqHisList(
  url: string,
  params?: EqHisRequest,
): Promise<AxiosResponse<EqHis[]>> {
  const config = createRequestConfig({ params });
  return axios.get<EqHis[]>(url, config);
}

// 設備点検情報件数の取得関数
export function requestCountEqHis(
  url: string,
  params?: EqHisRequest,
): Promise<AxiosResponse<number>> {
  const config = createRequestConfig({ params });
  return axios.get<number>(url, config);
}

// 設備点検の詳細情報の取得関数
export function requestEqHisDetail(
  url: string,
  params?: EqHisDetailRequest,
): Promise<AxiosResponse<EqHis>> {
  const config = createRequestConfig({ params });
  return axios.get<EqHis>(url, config);
}
